import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMailbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMailbox"><Path d="M17.5 4C19.9853 4 22 6.01472 22 8.5V20H14V22H12.5V8.5C12.5 6.70744 11.7131 5.09944 10.4668 4H17.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M6.5 4C8.98528 4 11 6.01472 11 8.5V20H2V8.5C2 6.09234 3.89083 4.12632 6.26855 4.00586L6.5 4ZM4.25 10.5H8.75V9H4.25V10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMailbox;
